import { atomWithDebounce, removeDiacritics } from '@rematter/ui-web';
import type { Atom } from 'jotai';
import { atom } from 'jotai';

import { contactListAtom } from '../_graphql/queryContactList';

import type { ParticipantCandidate } from './_types';
import { $selectedConversation } from './conversationList.state';

import type { QueryAtomReadValue } from '~/shared/providers/api/createQueryAtomFactory';

export const $contactsSearchTerm = atomWithDebounce('', 300);

export const $contactList = contactListAtom(() => ({
  variables: {
    // 🚧🚧🚧 Backend is not properly handling search term
    // so for now we're filtering client side
    // searchTerm: get($contactsSearchTerm.debouncedValue),
  },
}));

export const $filteredContactList: Atom<
  QueryAtomReadValue<ParticipantCandidate[]>
> = atom((get) => {
  const selectedConversation = get($selectedConversation);
  const searchTerm = get($contactsSearchTerm.debouncedValue);

  const normalizeForSearch = (value: string) =>
    removeDiacritics(value?.trim().toLowerCase());

  const normalizedTerms = normalizeForSearch(searchTerm).split(/\s+/);

  const participants = new Set(
    selectedConversation?.participants?.map(
      (participant) => participant.user.custom.applicationUserId,
    ),
  );

  const rawContactList = get($contactList);

  const filteredData = rawContactList.data?.filter(
    (contact) =>
      !participants.has(contact.id) &&
      normalizedTerms.every(
        (term) =>
          normalizeForSearch(contact.name).includes(term) ||
          normalizeForSearch(contact.email ?? '').includes(term) ||
          normalizeForSearch(contact.organizationName ?? '').includes(term),
      ),
  );

  return {
    ...rawContactList,
    data: filteredData,
  };
});
